import type { OrderStats } from "./product-types";

type CustomerPriceHistory = Pick<OrderStats,
  "daily_customer_price_rub_30d" | "daily_customer_price_30d"
  | "daily_customer_price_rub_count_30d" | "daily_customer_price_count_30d">;

/** Paid price over the last seven stored days, preferring normalized RUB series.
 * Keep the legacy fallback until all cached order snapshots have RUB fields. */
export function customerPriceAverage7d(stats: CustomerPriceHistory | undefined): number {
  const sum = (stats?.daily_customer_price_rub_30d ?? stats?.daily_customer_price_30d ?? []).slice(-7).reduce((a, b) => a + b, 0);
  const count = (stats?.daily_customer_price_rub_count_30d ?? stats?.daily_customer_price_count_30d ?? []).slice(-7).reduce((a, b) => a + b, 0);
  return count ? sum / count : 0;
}
